import { getConfig } from "../config";
import { ROOT_VERSION } from "../generated/rootVersion";

export const RELEASE_UPDATE_CHECK_INTERVAL_MS = 10 * 60 * 1000;

export const currentBuildMetadata = () => ({
  buildId: getConfig("REACT_APP_BUILD_ID", `local-${ROOT_VERSION}`),
  version: ROOT_VERSION,
  builtAt: getConfig("REACT_APP_BUILD_TIME", null),
});

export const parseBuildMetadata = value => {
  if (
    !value ||
    typeof value !== "object" ||
    typeof value.buildId !== "string" ||
    value.buildId.length === 0 ||
    typeof value.builtAt !== "string" ||
    !Number.isFinite(Date.parse(value.builtAt))
  ) {
    return null;
  }

  return {
    buildId: value.buildId,
    version: typeof value.version === "string" ? value.version : null,
    builtAt: value.builtAt,
  };
};

export const isNewerBuild = ({ currentBuild, latestBuild }) => {
  const current = parseBuildMetadata(currentBuild);
  const latest = parseBuildMetadata(latestBuild);

  if (!latest || latest.buildId === currentBuild?.buildId) return false;
  if (!current) return true;

  return Date.parse(latest.builtAt) > Date.parse(current.builtAt);
};

export const fetchLatestBuildMetadata = async ({
  fetchFunction = fetch,
  signal,
} = {}) => {
  const response = await fetchFunction("/version.json", {
    cache: "no-store",
    headers: {
      Accept: "application/json",
    },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch client version (${response.status})`);
  }

  const metadata = parseBuildMetadata(await response.json());
  if (!metadata) {
    throw new Error("Invalid client version metadata");
  }

  return metadata;
};
